<mat-paginator
  #paginator
  [length]="length"
  [pageSize]="pageSize"
  [pageSizeOptions]="pageSizeOptions"
  (page)="getDataPaginator($event)"
>
</mat-paginator>
